export default __webpack_public_path__ + "static/media/microscope.4a72285b.svg";